import axios from "axios";
import { API_URLs } from "../../../../../../utilities/API_URLs";
import { Http } from "../../../../../../utilities/axios/http";

export class HoldService {
    static getDebarkationMovementList = async (id: string, params?: any) => {
        try {
          return await Http.get(`${API_URLs.operations.salesOperations.hold.debarkationHoldUrl}/${id}`, params);
        } catch (error) {
          return error;
        }
      };

    static getEmbarkationMovementList = async (id: string, params?: any) => {
        try {
          return await Http.get(`${API_URLs.operations.salesOperations.hold.embarkationHoldUrl}/${id}`, params);
        } catch (error) {
          return error;
        }
      };

    static patchDebarkationMovement = async (data: any) => {
        try {
            return await Http.patch(API_URLs.operations.salesOperations.hold.debarkationHoldUrl, data)
        } catch (error) {
            return error
        }
    };

    static patchEmbarkationMovement = async (data: any) => {
        try {
            return await Http.patch(API_URLs.operations.salesOperations.hold.embarkationHoldUrl, data)
        } catch (error) {
            return error
        }
    };

    static patchHolds = async (terminason: string, data: any) => {
      try {
        const { id, ...rest } = data;
    
        return await Http.patchCustom(
          `${API_URLs.operations.commercialOperation.getOneOperations}/${id}/${terminason}`,
          rest
        );
      } catch (error) {
        throw error;
      }
    };
}
